import { routes } from '../constants/routes';
import { HideSectionsConfig } from '../schemas/apis/interface';

const ROUTE_PRIORITY: { path: string; sectionKey: string; label: string }[] = [
  { path: routes.agents, sectionKey: 'agents', label: 'Agents' },
  { path: routes.calls, sectionKey: 'call_logs', label: 'Call Logs' },
  {
    path: routes.knowledgeBase,
    sectionKey: 'knowledge_base',
    label: 'Knowledge Base',
  },
  {
    path: routes.phoneNumber,
    sectionKey: 'phone_numbers',
    label: 'Phone Numbers',
  },
  {
    path: routes.voiceLibrary,
    sectionKey: 'voice_library',
    label: 'Voice Library',
  },
  {
    path: routes.whatsappChats,
    sectionKey: 'whatsapp_chats',
    label: 'WhatsApp Chats',
  },
  { path: routes.analytics, sectionKey: 'agent_analytics', label: 'Analytics' },
  { path: routes.billing, sectionKey: 'billing', label: 'Billing' },
  {
    path: routes.manageUsers,
    sectionKey: 'manage_organization',
    label: 'Manage Organization',
  },
];

export const getFirstAvailableRoute = (
  hideSections?: HideSectionsConfig | null
): { path: string; label: string } => {
  if (!hideSections) return { path: routes.agents, label: 'Home' };

  for (const route of ROUTE_PRIORITY) {
    if (!hideSections[route.sectionKey]) {
      return { path: route.path, label: route.label };
    }
  }

  return { path: routes.agents, label: 'Home' };
};
